const users = {
    page_title: 'مدیریت کاربران',
    title: 'مدیریت کاربران',
    subtitle: 'هویت‌های کاربری را مدیریت کنید؛ شامل ایجاد کاربر، ویرایش اطلاعات، مشاهده گزارش‌ها، بازنشانی رمز عبور و حذف کاربران.',
    create: 'افزودن کاربر',
    create_subtitle: 'برای ادامه حداقل یکی از فیلدهای زیر را وارد کنید.',
    error_missing_identifier: 'برای ایجاد کاربر باید حداقل یک شناسه ارائه دهید.',
    user_name: 'کاربر',
    application_name: 'از برنامه',
    latest_sign_in: 'آخرین ورود',
    create_form_username: 'نام کاربری',
    create_form_password: 'رمز عبور',
    create_form_name: 'نام کامل',
    placeholder_name: 'John/Jane Doe',
    placeholder_email: 'jdoe@example.com',
    placeholder_username: 'user123',
    placeholder_phone: '+1 (555) 555-5555',
    unnamed: 'بدون نام',
    search: 'جستجو بر اساس نام، ایمیل، تلفن یا نام کاربری',
    check_user_detail: 'مشاهده جزئیات کاربر',
    placeholder_title: 'مدیریت کاربران',
    placeholder_description: 'هر کاربر پروفایلی دارد که شامل تمام اطلاعات کاربر است. این شامل داده‌های پایه، هویت‌های اجتماعی و داده‌های سفارشی است.',
    dev_tenant_data_retention_notice: 'در مستأجرهای توسعه، حساب‌های کاربری قدیمی‌تر از ۹۰ روز به‌صورت خودکار حذف می‌شوند. <a>بیشتر بدانید</a>',
};
export default Object.freeze(users);
